import React, { useEffect, useState } from "react";
import { Button, Col, Input, Label, Row, Table } from "reactstrap";
import _ from "lodash";
import { ItemTypeahead, ItemDropdownMenu, LabelSwitch } from "./";
import { api, constants, helpers, dateHelpers } from "../utils";
import { DesktopContainer } from "../layouts";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import SortHeader from "./SortHeader";
import ServiceThreadSpinner from "./ServiceThreadSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function InventoryLabels(props) {
   const WGT_MODEL = { index: 0, id: 0, item: "", site: "", numLabels: 0, wgt: 0 };
   const [classes, setClasses] = useState([]);
   const [classList, setClassList] = useState([]);
   const [data, setData] = useState(null);
   const [downloading, setDownloading] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [loaded, setLoaded] = useState();
   const [printers, setPrinters] = useState([]);
   const [printToPrinter, setPrintToPrinter] = useState(true);
   const [selectedPrinter, setSelectedPrinter] = useState(null);
   const [siteList, setSiteList] = useState([]);
   const [sites, setSites] = useState([]);
   const [sortDirection, setSortDirection] = useState("asc");
   const [sortField, setSortField] = useState("itemNumber");
   const [screenFields, setScreenFields] = useState({
      payload: {
         itemOrder: 1,
         orderRange: { label: "Two Weeks", value: "14" },
         classCode: "",
         abcCode: 0,
         vendor: "",
         itemNumberChecked: true,
         itemDescriptionPartialChecked: false,
         itemNumber: "",
         itemDescriptionPartial: "",
      },
      checked: true,
   });
   const [weights, setWeights] = useState(null);

   useEffect(() => {
      document.title = `Inventory Labels`
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      getItemClasses();
      getSites();
      getPrinters();
      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
      if (loaded) {
         getStockStatus();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [sortField, sortDirection]);

   function createInventoryLabels() {
      let payload = {};
      if (!selectedPrinter) {
         toast.error("Please pick a printer.");
         return;
      } else {
         payload.printerName = selectedPrinter.label;
         payload.printerId = selectedPrinter.value;
      }
      let quit = false;
      let labels = [];
      _.forEach(weights, function (value, index) {
         if (quit) return;
         let item = value;
         if (_.trim(item.wgt) === "") {
            toast.error("All weight entries are required");
            labels = [];
            quit = true;
            return;
         }
         if (isNaN(item.wgt)) {
            toast.error("All weight entries must be numeric");
            labels = [];
            quit = true;
            return;
         }
         if (item.wgt <= 0) {
            toast.error("All weight entries must be > 0");
            labels = [];
            quit = true;
            return;
         }
         if (!isNaN(item.wgt)) {
            labels.push({
               ItemNumber: item.item,
               NumberOfLabels: item.numLabels,
               SiteCode: item.site,
               Weight: item.wgt,
            });
         }
      });
      if (labels.length < 1) return;

      payload.Labels = labels;
      payload.PrintToPrinter = printToPrinter;
      setDownloading(true);
      if (payload.PrintToPrinter) {
         api
            .post("Printer/PrintInventoryLabels", payload)
            .then((response) => {
               if (response && response.data && response.data.success) {
                  toast.success("Labels were sent to the printer.");
                  resetLabelCount();
                  setWeights(null);
               } else {
                  toast.warning(response?.data?.message);
               }
            })
            .catch(() => {
               api.catchHandler();
            })
            .finally(() => {
               setDownloading(false)
            });
      } else {
         api
            .postDownloadBinary("Printer/PrintInventoryLabels", payload,
               constants.MIME_TYPES.pdf,
               `IV_Labels_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
               "There was an error downloading the labels.")
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
               else {
                  resetLabelCount();
                  setWeights(null);
               }
            })
            .catch(() => {
               api.catchHandler();
            })
            .finally(() => {
               setDownloading(false)
            });
      }
   }

   function exportXlsx() {
      if (!data.length) return;
      api
         .postGetBlob("Inventory/ExportInventoryLabelsXLSX", {
            ItemNumber: screenFields.payload.itemNumber?.value,
            ItemDescription: screenFields.payload?.itemDescriptionPartial,
            ABCCode: 0,
            ClassList: formatItemClassesString(classes),
            SiteList: formatItemClassesString(sites),
            ShowZeroQty: false,
            sortDirection: sortDirection,
            sortField: sortField,
            Mode: 1,
         })
         .then((response) => {
            if (!response.data) {
               toast.error(response.message || "Error downloading report");
               return;
            }
            if (response.data) {
               let XLSX_FILENAME = "InventoryLabels.xlsx";
               helpers.downloadExport(
                  response.data,
                  XLSX_FILENAME,
                  constants.MIME_XLSX
               );
            } else {
               throw new Error("Error downloading report");
            }
         });
   }

   function formatItemClassesString(list) {
      let newList = [];
      _.forEach(list, (x) => {
         newList.push(x.value);
      });
      return newList;
   }

   function formatPrinters(data) {
      let printerArr = _.concat(data.labels, data.lasers, data.parts);
      let list = _.map(printerArr, (x) => {
         return { label: x.nameOnly, value: x.id };
      });
      return list.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
   }

   function getItemClasses() {
      api
         .post("Reference/GetItemClasses", {})
         .then((response) => {
            if (response.data?.success) {
               if (response.data) {
                  setClassList({
                     list: _.map(response.data.itemClasses, (x) => x.itemClassCode),
                     ClassList: _.map(response.data.itemClasses, (x) => {
                        return {
                           label: x.itemClassWithDesc,
                           value: x.itemClassCode,
                        };
                     }),
                     success: true,
                  });
               }
            } else {
               toast.error("Failed to get Item Classes");
            }
         })
         .catch(api.catchHandler);
   }

   function getPrinters() {
      api
         .fetch("Printer/GetPrintersForDropdown")
         .then((response) => {
            if (response) {
               setPrinters(formatPrinters(response.data));
            } else {
               toast.error("Failed to get printers.");
            }
         })
         .catch(api.catchHandler);
   }

   function getSites() {
      api
         .fetch("Reference/GetSiteList")
         .then((response) => {
            if (response.data?.success) {
               if (response.data) {
                  setSiteList({
                     list: _.map(response.data.sites, (x) => x.siteDescription),
                     SiteList: _.map(response.data.sites, (x) => {
                        return { label: x.siteWithDescription, value: x.siteId };
                     }),
                     success: true,
                  });
               }
            } else {
               toast.error("Failed to get Sites.");
            }
         })
         .catch(api.catchHandler);
   }

   function getStockStatus() {
      setWeights(null);
      setIsLoading(true);
      api
         .post("Inventory/SearchStockStatus", {
            ItemNumber: screenFields.payload?.itemNumber?.value,
            ItemDescription: screenFields.payload?.itemDescriptionPartial,
            ABCCode: 0,
            ClassList: formatItemClassesString(classes),
            SiteList: formatItemClassesString(sites),
            ShowZeroQty: false,
            SortDirection: sortDirection,
            SortField: sortField,
            Mode: 1,
         })
         .then((response) => {
            if (response.data?.success) {
               if (response.data) {
                  setData(response.data.searchStockData);
                  setLoaded(true);
               }
            } else {
               toast.error("Failed to get Stock Status");
            }
         })
         .catch(api.catchHandler)
         .finally(() => setIsLoading(false));
   }

   const handleFocus = (event) => event.target.select();

   function initWeights() {
      let quit = false;
      let labels = [];
      let idx = 1;
      _.forEach(data, function (value, index) {
         if (quit) return;
         let item = value;
         if (_.trim(item.NumberOfLabels) !== "" && isNaN(item.NumberOfLabels)) {
            toast.error("Each label quantity must be a number");
            labels = [];
            quit = true;
            return;
         }
         if (!isNaN(item.NumberOfLabels) && item.NumberOfLabels !== 0) {
            for (let i = 0; i < item.NumberOfLabels; i++) {
               let changes = Object.assign({}, WGT_MODEL);
               changes.index = idx++;
               changes.id = i + 1;
               changes.item = item.itemNumber;
               changes.site = item.siteCode;
               changes.numLabels = 1; // Since not attached to a PO each label stands alone
               labels.push(changes);
            }
         }
      });
      if (labels.length > 0)
         setWeights(labels);
   }

   function isDecimalVal(str) {
      // One to five digits + optional decimal up to 4 places
      return (/^[0-9]{1,5}(\.[0-9]{0,4})?$/).test(str);
   }

   const onChange = (property, value, copy = null) => {
      if (copy === null) copy = _.cloneDeep(screenFields);
      _.set(copy, property, value);
      setScreenFields(copy);
      return;
   };

   function onLabelQuantityChange(field, value, index) {
      let newList = _.assign([], data);
      let parsedValue = parseInt(value, 10);
      let parsedField = parseInt(newList[index][field]);
      let isExistingBad = (isNaN(parsedField) || parsedField < 0 || !constants.IsPositiveNumber(newList[index][field]));
      if (value === undefined || value === "" || isNaN(parsedValue) || parsedValue < 0) {
         if (value !== "") toast.info("Number of labels must be numeric.");
         if (isExistingBad || value === "") 
            value = ""; // Existing value wasn't good or user wants to reset
         else 
            value = parsedField; // Existing value is good and user is not resetting
      }
      else if (!constants.IsPositiveNumber(value)) {
         if (isExistingBad) {
            // Existing value wasn't good so reset all row entries
            toast.info("Number of labels must be numeric.");
            value = "";
         }
         else {
            value = parsedField;
         }
      }

      newList[index][field] = value;
      setData(newList);
   }

   function onSortChange(field, direction) {
      if (field !== sortField) {
         setSortField(field);
         setSortDirection("asc");
      } else {
         setSortDirection(direction);
      }
   }

   function onWeightChange(field, value, index) {
      let newList = _.assign([], weights);
      let parsedValue = parseFloat(value);
      if (value === undefined || value === "" || !isDecimalVal(value) || parsedValue < 0) {
         let parsedField = parseFloat(newList[index][field]);
         if (isNaN(parsedField) || parsedField < 0 || !isDecimalVal(newList[index][field]))
            value = "0"; // Existing value wasn't good either so reset
         else
            value = parsedField; // Existing value is good, just keep it
         toast.info("Weight must be numeric with no more than 4 decimals");
      }
      else if (parsedValue > 25000) {
         value = "25000"
         toast.warning("Weight cannot exceed 25,000 lbs");
      }
      newList[index][field] = value;
      setWeights(newList);
   }

   const RadioButtonTypeAhead = (
      currentValue,
      PropertyToBecomeTrue,
      PropertyToBecomeFalse,
      PropertyToBecomeNull
   ) => {
      if (currentValue) return; // no need to switch it is already true
      const copy = _.cloneDeep(screenFields);
      _.set(copy, PropertyToBecomeTrue, true);
      _.set(copy, PropertyToBecomeFalse, false);
      _.set(copy, PropertyToBecomeNull, "");
      setScreenFields(copy);
   };

   function resetFilters() {
      resetLabelCount();
      setWeights(null);
      setData(null);
      setClasses([]);
      setSites([]);
      setScreenFields({
         payload: {
            itemOrder: 1,
            orderRange: { label: "Two Weeks", value: "14" },
            classCode: "",
            abcCode: 0,
            vendor: "",
            itemNumberChecked: true,
            itemDescriptionPartialChecked: false,
            itemNumber: "",
            itemDescriptionPartial: "",
         },
         checked: true,
      });
   }

   function resetLabelCount() {
      let labels = [];
      _.forEach(data, function (value, index) {
         let item = value;
         item.NumberOfLabels = 0;
         labels.push(item);
      });
      setData(labels);
   }

   return (
      <DesktopContainer screenName={"Inventory Labels"}>
         <div className="filter-header">
            <Row className="mt-3">
               <Col
                  xs="4"
                  style={{ color: "white" }}
                  className="d-flex justify-content-end p-1"
               >
                  <Label className="mx-2" style={{ fontSize: "1.25rem" }}>
                     <Input
                        type="checkbox"
                        name={"ItemNumber"}
                        className="mx-3"
                        checked={screenFields.payload.itemNumberChecked}
                        onChange={() =>
                           RadioButtonTypeAhead(
                              screenFields.payload.itemNumberChecked,
                              "payload.itemNumberChecked",
                              "payload.itemDescriptionPartialChecked",
                              "payload.itemDescriptionPartial"
                           )
                        }
                     />
                     Item Number
                  </Label>
               </Col>
               <Col xs="4">
                  <ItemTypeahead
                     value={screenFields.payload.itemNumber}
                     onChange={(opt) => onChange("payload.itemNumber", opt)}
                     disabled={screenFields.payload.itemDescriptionPartialChecked}
                  />
               </Col>
               <Col xs="3"></Col>
            </Row>
            <Row className="mt-2">
               <Col
                  xs="4"
                  style={{ color: "white" }}
                  className="d-flex justify-content-end p-1"
               >
                  <Label className="mx-2" style={{ fontSize: "1.25rem" }}>
                     <Input
                        type="checkbox"
                        name={"ItemDescriptionPartial"}
                        className="mx-3"
                        checked={screenFields.payload.itemDescriptionPartialChecked}
                        onChange={() =>
                           RadioButtonTypeAhead(
                              screenFields.payload.itemDescriptionPartialChecked,
                              "payload.itemDescriptionPartialChecked",
                              "payload.itemNumberChecked",
                              "payload.itemNumber"
                           )
                        }
                     />
                     Item Description Partial
                  </Label>
               </Col>
               <Col xs="4">
                  <Input
                     type="text"
                     name={"ItemDescriptionPartial"}
                     value={screenFields.payload.itemDescriptionPartial}
                     disabled={screenFields.payload.itemNumberChecked}
                     onChange={(e) => { onChange("payload.itemDescriptionPartial", e.target.value); }}
                  />
               </Col>
               <Col xs="3"></Col>
            </Row>
            <Row className="mt-2">
               <Col
                  xs={{ size: 4 }}
                  style={{ textAlign: "right", color: "white" }}
               >
                  <h5>Class:</h5>
               </Col>
               <Col xs="4">
                  <Select
                     classNamePrefix="serviceThreadSelect"
                     options={classList.ClassList}
                     value={classes}
                     onChange={(e) => setClasses(e)}
                     isMulti={true}
                     isClearable={true}
                  />
               </Col>
               <Col xs="3"></Col>
            </Row>
            <Row className="mt-2">
               <Col xs={{ size: 4 }} style={{ textAlign: "right", color: "white" }}>
                  <h5>Site:</h5>
               </Col>
               <Col xs="4">
                  <Select
                     classNamePrefix="serviceThreadSelect"
                     options={siteList.SiteList}
                     value={sites}
                     onChange={(e) => setSites(e)}
                     isMulti={true}
                     isClearable={true}
                  />
               </Col>
               <Col xs="3"></Col>
            </Row>
            <Row className="mt-3 d-flex justify-content-center">
               <Col xs="4">
                  <Button className="shredButton" onClick={() => resetFilters()}>
                     RESET
                  </Button>
                  <Button
                     className="shredButton mx-3"
                     disabled={isLoading}
                     onClick={() => getStockStatus()}
                  >
                     VIEW DATA
                  </Button>
               </Col>
            </Row>
         </div>
         {data ? (
            <ServiceThreadSpinner on={isLoading}>
               {!weights ? (
                  <Row className="mt-3 d-flex justify-content-center">
                     <Col xs="6"></Col>
                     <Col xs="2">
                        <Button
                           title="Download as .xlsx"
                           className="shredButtonExcel float-end ms-2"
                           onClick={() => exportXlsx()}
                        >
                           <FontAwesomeIcon icon="file-excel" size="lg" />
                        </Button>
                     </Col>
                  </Row>
               ) : null}
               <Row className="mt-3 d-flex justify-content-center">
                  <Col xs="8">
                     {!weights ? (
                        <div>
                           <Table size="sm" className="data-table">
                              <thead className="table-header">
                                 <tr>
                                    <th>
                                       <SortHeader
                                          displayName={"Item"}
                                          field={"ItemNumber"}
                                          sortDirection={sortDirection}
                                          sorted={sortField === "ItemNumber"}
                                          callback={onSortChange}
                                       />
                                    </th>
                                    <th>
                                       <SortHeader
                                          displayName={"Class"}
                                          field={"ItemClass"}
                                          sortDirection={sortDirection}
                                          sorted={sortField === "ItemClass"}
                                          callback={onSortChange}
                                       />
                                    </th>
                                    <th>Location</th>
                                    <th>On Hand</th>
                                    <th>Labels</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {_.map(data, (datum, index) => {
                                    return (
                                       <tr key={index}>
                                          <ItemDropdownMenu
                                             itemNumber={datum.itemNumber}
                                             itemDescription={datum.itemWithDescription}
                                             attachmentCount={datum.itemAttachmentCount}
                                          />
                                          <td className="data-cell">{datum.itemClass}</td>
                                          <td className="data-cell">{datum.siteCode}</td>
                                          <td className="data-cell">{helpers.formatNumberWithThousands(datum.qtyOnHand)}</td>
                                          <td className="data-cell">
                                             <Input
                                                type="text"
                                                value={data[index]?.NumberOfLabels}
                                                onChange={(e) => onLabelQuantityChange("NumberOfLabels", e.target.value, index)}
                                             />
                                          </td>
                                       </tr>
                                    );
                                 })}
                              </tbody>
                           </Table>
                           <Row className="mt-3">
                              <Col xs="11" style={{ textAlign: "left", marginRight: "5px" }}>
                                 <Button
                                    title="Add Weights"
                                    className="shredButton float-end ms-2"
                                    onClick={() => initWeights()}
                                 >Add Weight(s)  
                                 </Button>
                              </Col>
                           </Row>
                        </div>
                     ) : null}
                  </Col>
               </Row>
               {weights ? (
                  <div>
                  <Row className="mt-3 d-flex justify-content-center">
                     <Col xs="8">
                        <Table size="sm" className="data-table">
                           <thead className="table-header">
                              <tr>
                                 <th>Item</th>
                                 <th>Location</th>
                                 <th>#</th>
                                 <th>Weight</th>
                              </tr>
                           </thead>
                           <tbody>
                              {_.map(weights, (datum, index) => {
                                 return (
                                    <tr key={index}>
                                       <td className="data-cell">{datum.item}</td>
                                       <td className="data-cell">{datum.site}</td>
                                       <td className="data-cell">{datum.id}</td>
                                       <td className="data-cell">
                                          <Input
                                             type="number"
                                             className="no-spinner"
                                             value={weights[index]?.wgt}
                                             onFocus={handleFocus}
                                             onChange={(e) => onWeightChange("wgt", e.target.value, index)}
                                          />
                                       </td>
                                    </tr>
                                 );
                              })}
                           </tbody>
                        </Table>
                     </Col>
                  </Row>
                  <Row className="mt-3 d-flex justify-content-center">
                     <Col xs="11">
                        <Row className="mt-3">
                           <Col className="centerRight" xs="5" style={{ textAlign: "left", marginRight: "5px" }}>
                              <label htmlFor="printer-list" style={{ marginRight: '10px' }}>Printers:</label>
                              <Select id="printer-list"
                                 styles={{
                                    container: (provided) => ({
                                       ...provided,
                                       display: 'inline-block',
                                       width: '300px'
                                    })
                                 }}
                                 classNamePrefix="serviceThreadSelect"
                                 options={printers}
                                 value={selectedPrinter}
                                 onChange={(e) => setSelectedPrinter(e)}
                                 isMulti={false}
                                 isClearable={false}
                              />
                           </Col>
                           <Col xs="6">
                              <LabelSwitch
                                 displayName="Print to Printer?"
                                 buttonLabel="CREATE LABELS"
                                 onChangeCallback={(e) => setPrintToPrinter(e)}
                                 onButtonClick={createInventoryLabels}
                                 disabled={downloading}
                              />
                           </Col>
                        </Row>
                     </Col>
                  </Row>
                  </div>
               ) : null}
            </ServiceThreadSpinner>
         ) : null}
      </DesktopContainer>
   );
}
